module.exports = __webpack_public_path__ + "media/img/trainings/counter-bg-cf36f12e256067fc31b89d1686c64c4a.svg";